/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const E = "expanded", I = "text", D = "disabled", e = "items", _ = "hasChildren", t = "selected", n = "svgIcon", c = "checked", s = "checkIndeterminate", o = "_kendoItemId", L = "_kendoTreeViewGuid";
export {
  c as CHECK_FIELD,
  s as CHECK_INDETERMINATE_FIELD,
  e as CHILDREN_FIELD,
  D as DISABLED_FIELD,
  o as DOM_KENDO_ITEM_ID_FIELD,
  L as DOM_KENDO_TREEVIEW_GUID_FIELD,
  E as EXPAND_FIELD,
  _ as HAS_CHILDREN_FIELD,
  n as ICON_FIELD,
  t as SELECT_FIELD,
  I as TEXT_FIELD
};
